import {SLQueryParamConfig} from '#/contexts/query-params-provider';
import {WalletContext} from '#/contexts/wallet-provider';
import {MarketDataTickerEmbed} from '#/pages/embeds/market-data-ticker-embed';
import {MarketPriceTickerEmbed} from '#/pages/embeds/market-price-ticker-embed';
import {TrendingLandsEmbed} from '#/pages/embeds/trending-lands-embed';
import HomePage from '#/pages/home';
import MapPage from '#/pages/map';
import {PortfolioPage} from '#/pages/portfolio';
import {PortfolioAccountPage} from '#/pages/portfolio/account';
import {Wiki} from '#/pages/wiki';
import {EmbedRoute} from '#/routes/embed/embed-route';
import {EmbedRoutesElement} from '#/routes/embed/embed-routes';
import {ExchangeRoute} from '#/routes/exchange/exchange-route';
import {ExchangeRoutesElement} from '#/routes/exchange/exchange-routes';
import {getExchangeRouteWithQueryParams} from '#/routes/exchange/get-exchange-route-with-query-params';
import {DefaultChildren} from '#/utils/utils';
import {isEqualLowerCase} from '@shareland/shareland-common';
import {FunctionComponent, useContext} from 'react';
import {Navigate, Route, Routes, useParams} from 'react-router';
import {useQueryParams} from 'use-query-params';

// TODO move layout and page to the root level so that you don't have to remount those components on page switch
export const AppRoutes: FunctionComponent = () => {
  return (
    <Routes>
      <Route element={<ExchangeRoutesElement />}>
        <Route index path={ExchangeRoute.HOME} element={<HomePage />} />
        <Route path={ExchangeRoute.HOW_IT_WORKS} element={<Wiki />} />
        <Route path={ExchangeRoute.MAP} element={<MapPage />} />
        <Route path={ExchangeRoute.PORTFOLIO} element={<PortfolioPage />} />
        <Route
          path={ExchangeRoute.PORTFOLIO_ACCOUNT}
          element={
            <AccountToUserPortfolioRedirect>
              <PortfolioAccountPage />
            </AccountToUserPortfolioRedirect>
          }
        />
      </Route>

      {/* Disabling the route since it is not bein used 
      <Route element={<AdminRoutesElement />}>
        <Route path={AdminRoute.ORACLE_VALIDATION} element={<OracleValidationPage />} />
      </Route> */}

      <Route element={<EmbedRoutesElement />}>
        <Route path={EmbedRoute.TRENDING_LANDS} element={<TrendingLandsEmbed />} />
        <Route path={EmbedRoute.LAND_MARKET_PRICE_TICKER} element={<MarketPriceTickerEmbed />} />
        <Route path={EmbedRoute.LAND_MARKET_DATA_TICKER} element={<MarketDataTickerEmbed />} />
      </Route>
    </Routes>
  );
};

const AccountToUserPortfolioRedirect: FunctionComponent<DefaultChildren> = ({children}) => {
  const {
    accountResult: {address: account, isConnected},
  } = useContext(WalletContext);

  const urlParams = useParams();
  const [queryParams] = useQueryParams<SLQueryParamConfig>();

  if (isConnected && account && urlParams.account && isEqualLowerCase(account, urlParams.account)) {
    const to = getExchangeRouteWithQueryParams(ExchangeRoute.PORTFOLIO, {
      ...queryParams,
    });

    return <Navigate to={to} replace />;
  }

  return <>{children}</>;
};
